import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { ClientRegisterModel } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class ApiClientRegisterService extends ApiListDataService<
    ClientRegisterModel,
    ClientRegisterModel
> {
    constructor(http: HttpClient) {
        super(http, '/Client/ViewByContract/');
    }
}
